import {useIntl, FormattedMessage} from 'react-intl'
import {useState} from 'react'
import {Link} from 'react-router-dom'
import {toAbsoluteUrl} from '../../../_gori/helpers'
import {StartFreeToday} from './components/StartFreeToday'
import {PublicWrapper} from '../../modules/common/components/PublicWrapper'
import {ROUTES} from '../../../_gori/constants'
import {Carousel} from 'react-bootstrap'

export function GoriSignaturePage() {
  const intl = useIntl()
  const [activeStatus, setActiveStatus] = useState<'paid' | 'fraud' | 'pending' | 'expired'>('paid')

  const statusTabs = [
    {
      key: 'paid' as const,
      labelId: 'GORI_SIGNATURE_PAGE_RESULT_PAID',
      icon: '/media/gori/gori-signature/icon-verified.svg',
    },
    {
      key: 'pending' as const,
      labelId: 'GORI_SIGNATURE_PAGE_RESULT_PENDING',
      icon: '/media/gori/gori-signature/icon-pending.svg',
    },
    {
      key: 'fraud' as const,
      labelId: 'GORI_SIGNATURE_PAGE_RESULT_REJECTED',
      icon: '/media/gori/gori-signature/icon-fraud.svg',
    },
    {
      key: 'expired' as const,
      labelId: 'GORI_SIGNATURE_PAGE_RESULT_EXPIRED',
      icon: '/media/gori/gori-signature/icon-expired.svg',
    },
  ]

  const statusPanels = {
    paid: {
      image: '/media/gori/gori-signature/status-paid.webp',
      titleId: 'GORI_SIGNATURE_PAGE_SMART_RESULTS_NEXT_TITLE',
      descriptionId: 'GORI_SIGNATURE_PAGE_STATUS_PASS_DESCRIPTION',
    },
    fraud: {
      image: '/media/gori/gori-signature/status-rejected.webp',
      titleId: 'GORI_SIGNATURE_PAGE_SMART_RESULTS_NEXT_TITLE',
      descriptionId: 'GORI_SIGNATURE_PAGE_STATUS_FRAUD_DESCRIPTION',
    },
    pending: {
      image: '/media/gori/gori-signature/status-pending.webp',
      titleId: 'GORI_SIGNATURE_PAGE_SMART_RESULTS_NEXT_TITLE',
      descriptionId: 'GORI_SIGNATURE_PAGE_STATUS_PENDING_DESCRIPTION',
    },
    expired: {
      image: '/media/gori/gori-signature/status-expired.webp',
      titleId: 'GORI_SIGNATURE_PAGE_SMART_RESULTS_NEXT_TITLE',
      descriptionId: 'GORI_SIGNATURE_PAGE_STATUS_EXPIRED_DESCRIPTION',
    },
  }

  const carouselItems = [
    {
      image: '/media/gori/gori-signature/how-it-works-step-2.webp',
      titleId: 'GORI_SIGNATURE_PAGE_HOW_IT_WORKS_STEP_1_TITLE',
      descriptionId: 'GORI_SIGNATURE_PAGE_HOW_IT_WORKS_STEP_1_DESCRIPTION',
      alt: 'Scan Your Label',
    },
    {
      image: '/media/gori/gori-signature/how-it-works-step-3.webp',
      titleId: 'GORI_SIGNATURE_PAGE_HOW_IT_WORKS_STEP_2_TITLE',
      descriptionId: 'GORI_SIGNATURE_PAGE_HOW_IT_WORKS_STEP_2_DESCRIPTION',
      alt: 'Get Verified Results',
    },
  ]

  return (
    <PublicWrapper>
      <div className='gori-signature-page-container'>
        {/* Hero Section */}
        <section className='hero py-100px'>
          <img
            className='d-block mx-auto mb-4'
            src={toAbsoluteUrl('/media/gori/gori-signature/gori-signature.svg')}
            alt='Gori Signature'
          />
          <p className='text-center poppins fw-bold mb-6'>
            {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_HERO_SUBTITLE'})}
          </p>
          <Link
            to={ROUTES.PRODUCTS.GORI_SIGNATURE}
            className='btn btn-outline btn-primary-deep hover-orange rounded-pill text-center d-block w-fit-content mx-auto'
          >
            {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_VERIFY_LABELS_CTA'})}
          </Link>
        </section>

        {/* What Is Gori Signature? */}
        <section className='what-is-gori-signature bg-white py-100px'>
          <div className='container'>
            <div className='text-header-wrapper'>
              <h2 className='text-center raleway mb-6'>
                {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_WHAT_IS_TITLE'})}
              </h2>
              <p className='text-center poppins fw-bold'>
                {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_WHAT_IS_DESCRIPTION'})}
              </p>
            </div>
            <div className='img-container d-flex align-items-center justify-content-center'>
              <img
                className='mh-100 mw-100'
                src={
                  'https://gori-ai.s3.us-west-2.amazonaws.com/shipbae-assets/gori_signature/what-is-gori-signature.gif'
                }
                alt='What is Gori Signature'
              />
            </div>
          </div>
        </section>

        {/* Smart Results, Zero Confusion */}
        <section className='smart-results py-100px'>
          <div className='container'>
            <div className='text-header-wrapper'>
              <h2 className='text-center raleway mb-6'>
                {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_SMART_RESULTS_TITLE'})}
              </h2>
              <p className='text-center poppins fw-bold'>
                {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_SMART_RESULTS_SUBTITLE'})}
                <br />
                {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_SMART_RESULTS_SALES_CTA'})}
              </p>
            </div>

            <div className='status-tabs d-flex flex-wrap justify-content-center gap-4'>
              {statusTabs.map((tab) => (
                <button
                  key={tab.key}
                  type='button'
                  className={`status-tab ${activeStatus === tab.key ? 'active' : ''}`}
                  onClick={() => setActiveStatus(tab.key)}
                >
                  {intl.formatMessage({id: tab.labelId})}
                  {tab.icon && (
                    <img src={toAbsoluteUrl(tab.icon)} alt='' className='status-tab__icon' />
                  )}
                </button>
              ))}
            </div>

            <div className='status-panel d-flex flex-column flex-lg-row align-items-center justify-content-center gap-10'>
              <img
                className='status-panel__image'
                src={toAbsoluteUrl(statusPanels[activeStatus].image)}
                alt={activeStatus}
              />
              <div className='status-panel__content'>
                <h3 className='mb-2'>
                  {intl.formatMessage({id: statusPanels[activeStatus].titleId})}
                </h3>
                <p>
                  <FormattedMessage
                    id={statusPanels[activeStatus].descriptionId}
                    values={{
                      br: <br />,
                      helpCenterLink: (chunks: React.ReactNode) => (
                        <Link
                          to={ROUTES.HELP_CENTER.MANAGE_SHIPMENT.GORI_SIGNATURE}
                          className='p-0 btn-advanced-editorial fs-inherit'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          {chunks}
                        </Link>
                      ),
                      uspsLink: (chunks: React.ReactNode) => (
                        <a
                          href='https://www.uspis.gov/report'
                          target='_blank'
                          rel='noopener noreferrer'
                          className='p-0 btn-advanced-editorial fs-inherit'
                        >
                          {chunks}
                        </a>
                      ),
                    }}
                  />
                </p>
              </div>
            </div>
            <a
              href='mailto:sales@goricompany.com'
              className='btn btn-outline btn-primary-deep hover-orange rounded-pill text-center d-block w-fit-content mx-auto'
            >
              {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_REQUEST_ACTIVATION_CTA'})}
            </a>
          </div>
        </section>

        {/* Why Gori Signature? */}
        <section className='why-gori-signature bg-white py-80px'>
          <div className='container'>
            <div className='text-header-wrapper'>
              <h2 className='text-center raleway mb-6'>
                {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_WHY_TITLE'})}
              </h2>
              <p className='text-center poppins fw-bold'>
                {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_WHY_SUBTITLE'})}
              </p>
            </div>
            <div className='d-flex flex-column flex-md-row justify-content-center align-items-stretch gap-7'>
              <div className='why-item'>
                <img
                  src={toAbsoluteUrl('/media/gori/gori-signature/stop-fraud.svg')}
                  alt='Stop Fraud Before It Becomes a Problem'
                  className='mb-4'
                />
                <h3>{intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_WHY_1_TITLE'})}</h3>
                <p>{intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_WHY_1_DESCRIPTION'})}</p>
              </div>
              <div className='why-item'>
                <img
                  src={toAbsoluteUrl('/media/gori/gori-signature/minimize-disruptions.svg')}
                  alt='Minimize Carrier Disruptions'
                  className='mb-4'
                />
                <h3>{intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_WHY_2_TITLE'})}</h3>
                <p>{intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_WHY_2_DESCRIPTION'})}</p>
              </div>
              <div className='why-item'>
                <img
                  src={toAbsoluteUrl('/media/gori/gori-signature/boost-confidence.svg')}
                  alt='Boost Confidence for Merchants & Customers'
                  className='mb-4'
                />
                <h3>{intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_WHY_3_TITLE'})}</h3>
                <p>{intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_WHY_3_DESCRIPTION'})}</p>
              </div>
            </div>
          </div>
        </section>

        {/* How It Works */}
        <section className='how-it-works py-80px'>
          <div className='container'>
            <h2 className='text-center raleway'>
              {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_HOW_IT_WORKS_TITLE'})}
            </h2>
            <Carousel className='mb-19' interval={3000} touch={true} indicators>
              {carouselItems.map((item, index) => (
                <Carousel.Item key={index}>
                  <div className='d-flex flex-column flex-lg-row justify-content-center align-items-center gap-20'>
                    <img
                      src={toAbsoluteUrl(item.image)}
                      alt={item.alt}
                      className='how-it-works-img'
                    />
                    <div>
                      <h3 className='mb-4'>{intl.formatMessage({id: item.titleId})}</h3>
                      <p className='mb-4'>
                        <FormattedMessage
                          id={item.descriptionId}
                          values={{
                            br: <br />,
                            goriSignatureLink: (chunks: React.ReactNode) => (
                              <Link
                                to={ROUTES.GORI_SIGNATURE.BASE}
                                className='p-0 btn-advanced-editorial fs-inherit'
                              >
                                {chunks}
                              </Link>
                            ),
                          }}
                        />
                      </p>
                    </div>
                  </div>
                </Carousel.Item>
              ))}
            </Carousel>

            <a
              href='mailto:sales@goricompany.com'
              className='btn btn-outline btn-primary-deep hover-orange rounded-pill text-center d-block w-fit-content mx-auto'
            >
              {intl.formatMessage({id: 'GORI_SIGNATURE_PAGE_REQUEST_ACTIVATION_CTA'})}
            </a>
          </div>
        </section>

        <StartFreeToday />
      </div>
    </PublicWrapper>
  )
}
